import NendaError from "@server/utils/error";
import { BaseEntity } from "../baseEntity";
import { NendaProduct } from "@nendaTypes/NendaTypes";

// export enum FEATURE_SET_PRODUCTS {
//   "STREAMING_APP" = "Streaming App",
//   "FRONTLAYER" = "Frontlayer",
//   "SIGNAGE" = "Signage",
//   "SIGNAL_DELIVERY" = "Signal Delivery",
// }

export enum FEATURE_SET_FEATURES {
  "CONTINOUS_STREAMING" = "Continuous Streaming",
  "OWN_VIDEOS" = "Own Videos",
  "FAST_CHANNELS" = "Fast Channels",
  "SIGNAGE" = "Signage",
  "EXTERNAL_ADS" = "External Ads",
}

export class FeatureSetProduct extends BaseEntity {
  product: NendaProduct;
  features: FEATURE_SET_FEATURES[];

  constructor() {
    super();
  }

  getUniqueId(): string {
    return this.product;
  }

  getDisplayName(): string {
    return this.product;
  }
}

export class FeatureSet extends BaseEntity {
  externalRef: string;
  enabled: boolean;
  description: string;

  mediaCollections: string[];
  products: FeatureSetProduct[];

  getUniqueId() {
    return this._id;
  }

  getDisplayName() {
    return this.name;
  }

  serialize() {
    return {
      _id: this._id,
      name: this.name,
      externalRef: this.externalRef,
      enabled: this.enabled,
      description: this.description,

      mediaCollections: this.mediaCollections,
      products: this.products,
      type: this.type,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}
